module.exports = __webpack_public_path__ + "img/Katrin-Schreiner_Portrait.beacf139.jpg";